import { render, staticRenderFns } from "./EditCredentialForm.vue?vue&type=template&id=6c6be720&scoped=true"
import script from "./EditCredentialForm.vue?vue&type=script&lang=js"
export * from "./EditCredentialForm.vue?vue&type=script&lang=js"
import style0 from "./EditCredentialForm.vue?vue&type=style&index=0&id=6c6be720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6be720",
  null
  
)

export default component.exports